import request from '@/utils/requestBlog'
const api = {
    getChildrenArticleById: '/column/getChildrenArticleById',
    getArticleById: '/article/getArticleById'
}
export default api
// 获取文章menu树形结构
export function getChildrenArticleById(data) {
    return request({
        url: api.getChildrenArticleById,
        method: 'post',
        data
    })
}
// 获取文章详情
export function getArticleById(data) {
    return request({
        url: api.getArticleById,
        method: 'post',
        data
    })
}